import { memo } from 'react';

import Stack from '@mui/material/Stack';
import { CHART_OPTIONS } from '@mais-retorno-front/libs/util-helpers';
import { Card } from '@core/design-system/card/app';

import {
  ProfitChart,
  SpaceBox,
  Title,
} from '@mais-retorno-front/components/profit-chart';
import { Benchmark } from '@mais-retorno-front/libs/feature-profit-chart/lib/components/benchmark';
import { Select } from '@core/design-system/input';
import { PeriodSelect } from '@core/design-system/period-select';

import { useAccumulatedMovableWindow } from '../../hook';
import { MOVABLE_WINDOWS_OPTIONS } from '../../constant';
import { MovableWindowsProps } from '../../interface';

export const MovableWindowChart = memo<MovableWindowsProps>(
  ({
    assetsIdentifiers,
    firstQuoteDate,
    lastQuoteDate,
    nicename,
    currency,
  }) => {
    const {
      series,
      calculatedPeriod,
      loading,
      onBenchmarksChange,
      onWindowChange,
      onPeriodChange,
    } = useAccumulatedMovableWindow({
      assetsIdentifiers,
      currency,
      period: {
        startDate: firstQuoteDate,
        endDate: lastQuoteDate,
      },
    });

    return (
      <Card>
        <SpaceBox>
          <Title title="Gráfico de Janelas Móveis" description={nicename} />
          <Stack
            flexDirection="row"
            flexWrap="wrap"
            alignItems="flex-start"
            gap={1}
          >
            <Select
              variant="outlined"
              startAdornment="Janela:&nbsp;"
              size="small"
              defaultValue={'12'}
              onChange={(e: any) => onWindowChange(e.target.value)}
              options={MOVABLE_WINDOWS_OPTIONS}
              sx={{ width: 'fit-content', height: '31px' }}
            />

            <Benchmark
              onSelectedBenchmarksChange={onBenchmarksChange}
              hasMinBenchmarkLimit={false}
            />

            <PeriodSelect
              minStartDate={firstQuoteDate}
              maxEndDate={lastQuoteDate}
              onChangePeriod={onPeriodChange}
            />
          </Stack>
        </SpaceBox>

        <ProfitChart
          series={series}
          loading={loading}
          options={CHART_OPTIONS.percentChart}
          firstSerieDate={calculatedPeriod?.startDate}
          lastSerieDate={calculatedPeriod?.endDate}
        />
      </Card>
    );
  }
);
